import React from "react";
import { CollapseFAQ, H3, NamedLink } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

import SeasideImage from '../images/IMG_7883.jpg'
import TravelLoafersImage from '../images/Travel loafers - Dianne and Mike in Oxfordshire with Hudson and K2.jpg';
import GlobalIcon from '../images/global.png';
import SupportIcon from '../images/support.png';
import ValueIcon from '../images/value.png';
import VerificationIcon from '../images/verification.png';

import EuropeImage from '../images/europe.png';
import USAImage from '../images/usa.png';
import CanadaImage from '../images/canada.png';
import AustraliaImage from '../images/australia.png';

import css from '../HouseSittingAbroadPage.module.css';
import { defaultFaq } from "./faqs";
import SectionHero from "../../../components/StaticPageContainers/SectionHero";
import ContinueIcon from '../../TopbarContainer/Topbar/images/continue-icon.svg';
import { userTypes } from "../../../util/userTypes";
import SectionGrid421 from "../../../components/StaticPageContainers/SectionGrid421";
import SectionGrid21 from "../../../components/StaticPageContainers/SectionGrid21";
import SectionGrid41 from "../../../components/StaticPageContainers/SectionGrid41";
import SectionGrid31 from "../../../components/StaticPageContainers/SectionGrid31";
import AvatarPlaceholder from '../images/avatar_placeholder.png';
import SectionSimpleContainer from "../../../components/StaticPageContainers/SectionSimpleContainer";
import TrustWidgetSmall from "../../../components/StaticPageContainers/TrustWidgetSmall";

const DefaultPage = props => {

    const faq = [
        {
            question: "Can couples or families house sit abroad?",
            answer: "Yes. Many homeowners welcome couples; some are open to families. Confirm sleeping arrangements, pet routines, and any child-related considerations before you commit.",
        },
        {
            question: "Do I need previous pet care experience to sit overseas?",
            answer: "Experience helps. Homeowners often look for references and reviews. Be clear about the pets you’re confident with and add relevant experience to your profile.",
        },
        {
            question: "Are international house sits paid?",
            answer: "Most sits on our platform are based on an exchange (care for accommodation). Any expenses or allowances should be agreed in writing in advance.",
        },
        {
            question: "How long do overseas house sits usually last?",
            answer: "Durations vary from short breaks to several months. Align on arrival/hand-over times, daily routines, and any seasonal tasks (e.g., heating, garden or pool care).",
        },
        {
            question: "What about visas and travel insurance?",
            answer: "Check entry rules for your nationality and length of stay, and consider travel insurance with medical and liability cover. Keep confirmations and contact details handy.",
        },
        {
            question: "What if something goes wrong while I’m abroad?",
            answer: "Use the agreed emergency contacts, contact the homeowner promptly, and seek local vet/help as needed. Keep key numbers and instructions in the handover pack.",
        },
    ]
    return (
        <div className={css.rootNew}>

            <SectionHero
                imageUrl={SeasideImage}
                header={
                    <H3>
                        House Sitting Abroad
                    </H3>
                }
                content={
                    <>
                        <p className={css.info}>
                            HouseSit Match helps you arrange trusted house and pet sitting across borders. Sitters enjoy affordable, comfortable stays, while homeowners keep pets happy at home with verified care and ongoing support.
                        </p>


                        <div className="rowMobile fitWidth cenSelf gap20">
                            <NamedLink
                                className={css.ctaButton}
                                name="MembershipPlansPage"
                                params={{ accountType: userTypes.homeowner }}>
                                Explore Memberships for Homeowners
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>

                            <NamedLink
                                className={css.ctaButton}
                                name="MembershipPlansPage"
                                params={{ accountType: userTypes.housesitter }}>
                                Explore Memberships for Sitters
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>
                        </div>

                        {/* <p className={css.info}>
                            ⭐ Rated Excellent on Trustpilot (4.8 / 5) 
                        </p> */}
                        <TrustWidgetSmall text="• Verified members • UK-based support since 2013" />

                    </>}
            />

            <SectionGrid421
                backgroundColor="white"
                header={
                    <>
                        <p className={css.sectionTitle}>
                            Why Choose HouseSit Match for House Sitting Abroad
                        </p>

                        <p className={css.info}>
                            International house sitting works best with clarity, safety and support. We bring those together with verification, clear expectations and guidance so both sides feel confident before and during a sit abroad.
                        </p>
                    </>
                }
                content={
                    <>
                        <div className={css.card}>
                            <img src={GlobalIcon} className={css.cardImage} />

                            <H3>
                                Global Coverage
                            </H3>
                            <p className={css.info}>
                                Members arrange sits across Europe, North America, Australia & New Zealand, Asia and beyond, making international house sitting simple for both sides.
                            </p>
                        </div>

                        <div className={css.card}>
                            <img src={VerificationIcon} className={css.cardImage} />

                            <H3>
                                Verification & Reviews
                            </H3>
                            <p className={css.info}>
                                Profiles include ID checks, references and post-sit reviews so homeowners and sitters can make confident decisions.
                            </p>
                        </div>

                        <div className={css.card}>
                            <img src={SupportIcon} className={css.cardImage} />

                            <H3>
                                Clear Expectations & Support
                            </H3>
                            <p className={css.info}>
                                Agree responsibilities up front, message securely and access friendly help if you need guidance before or during a sit abroad.
                            </p>
                        </div>

                        <div className={css.card} >
                            <img src={ValueIcon} className={css.cardImage} />

                            <H3>
                                Great Value Memberships
                            </H3>
                            <p className={css.info}>
                                Register free to explore the service. Choose a sitter or homeowner plan when you’re ready to connect.
                            </p>
                        </div>
                    </>
                }
                footer={
                    <>
                        <div className="col cenV fitWidth cenSelf gap20">
                            <NamedLink
                                className={css.ctaButton}
                                name="WhatIsHouseSittingPage" >
                                Learn How It Works
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>
                        </div>
                    </>
                } />


            <SectionGrid21
                style={{ gap: "0 !important" }}
                header={
                    <>
                        <p className={css.sectionTitle}>
                            Explore Our House Sitting Services by Region
                        </p>

                        <p className={css.info}>
                            Explore our overseas regions. Learn how the service works, what memberships include and practical guidance for sitters and homeowners.
                        </p>
                        <p className={css.info}>
                            Looking for UK guidance?  <NamedLink className={css.link}
                                name="HouseSittingUK">
                                See house sitting services in the UK
                            </NamedLink>

                        </p>
                    </>}
                content={
                    <>
                        <div className={css.overlayParent}>
                            <img src={EuropeImage} className={css.overlayImage} />
                            <div className={css.overlayContainer}>
                                <p className={css.subtitle}>
                                    House Sitting in Europe
                                </p>
                                <p className={css.info}>
                                    Plan around common stay limits and varied pet routines in city flats and rural homes; agree duties clearly across languages.
                                </p>
                                <NamedLink className={css.linkLight}
                                    name="EuropeHouseSittingAbroadRedirect">
                                    View
                                </NamedLink>
                            </div>
                        </div>

                        <div className={css.overlayParent}>
                            <img src={USAImage} className={css.overlayImage} />
                            <div className={css.overlayContainer}>
                                <p className={css.subtitle}>
                                    House Sitting in the USA
                                </p>
                                <p className={css.info}>
                                    Expect suburban homes and car use; confirm HOA rules, pet routines and vet info before you commit.
                                </p>
                                <NamedLink className={css.linkLight}
                                    name="UsaHouseSittingAbroadRedirect">
                                    View
                                </NamedLink>
                            </div>
                        </div>

                        <div className={css.overlayParent}>
                            <img src={CanadaImage} className={css.overlayImage} />
                            <div className={css.overlayContainer}>
                                <p className={css.subtitle}>
                                    House Sitting in Canada
                                </p>
                                <p className={css.info}>
                                    Be ready for colder seasons; align on heating, snow or yard care and access to local vets.
                                </p>
                                <NamedLink className={css.linkLight}
                                    name="CanadaHouseSittingAbroadRedirect">
                                    View
                                </NamedLink>
                            </div>
                        </div>

                        <div className={css.overlayParent}>
                            <img src={AustraliaImage} className={css.overlayImage} />
                            <div className={css.overlayContainer}>
                                <p className={css.subtitle}>
                                    House Sitting in Australia
                                </p>
                                <p className={css.info}>
                                    Longer sits are common; discuss garden or pool care, heat plans for pets and basic biosecurity expectations.
                                </p>
                                <NamedLink className={css.linkLight}
                                    name="AustraliaHouseSittingAbroadRedirect">
                                    View
                                </NamedLink>
                            </div>
                        </div>


                    </>
                }
                footer={<>

                    <div className="col cenV fitWidth cenSelf gap20">
                        <NamedLink
                            className={css.ctaButton}
                            name="SearchHouseSitPage" >
                            View All Overseas House Sitting Opportunities
                            <img src={ContinueIcon} className={css.icon} />
                        </NamedLink>
                    </div>
                </>
                } />


            <SectionGrid41
                backgroundColor="white"
                header={
                    <>
                        <p className={css.sectionTitle}>
                            How House Sitting Works Abroad
                        </p>
                        <p className={css.info}>
                            A clear process keeps cross-border sits smooth for everyone. Here’s how to set up trusted arrangements overseas with HouseSit Match.
                        </p>
                    </>
                }
                content={
                    <>
                        <div className={css.stepContainer}>
                            <H3>
                                <span class={css.circleNumber}>1</span>
                                Create Your Free Account
                            </H3>
                            <p className={css.info}>
                                Choose a <NamedLink className={css.link}
                                    name="SignupPage">
                                    sitter or homeowner account.
                                </NamedLink> You can browse our service and resources, then pick a membership when you’re ready to connect.
                            </p>
                        </div>
                        <div className={css.stepContainer}>
                            <H3>
                                <span class={css.circleNumber}>2</span>
                                Build a Strong Profile
                            </H3>
                            <p className={css.info}>
                                Add photos, experience and pet preferences (sitters) or home, pets and responsibilities (homeowners). Complete ID checks and references for trust.
                            </p>
                        </div>
                        <div className={css.stepContainer}>
                            <H3>
                                <span class={css.circleNumber}>3</span>
                                Connect and Confirm Details
                            </H3>
                            <p className={css.info}>
                                Use secure messaging and a video call to agree dates, pet routines, home care, Wi-Fi, transport, and any region-specific points (e.g., heating, HOA, visas). Confirm in writing.
                            </p>
                        </div>
                        <div className={css.stepContainer}>
                            <H3>
                                <span class={css.circleNumber}>4</span>
                                Prepare, Sit and Review
                            </H3>
                            <p className={css.info}>
                                Share emergency contacts and vet info. During the sit, keep simple updates. Afterward, both sides leave a review to grow trust across the community.
                            </p>
                        </div>
                    </>
                }
                footer={
                    <>
                        <div className="rowMobile fitWidth cenSelf gap20">
                            <NamedLink
                                className={css.ctaButton}
                                name="MembershipPlansPage"
                                params={{ accountType: userTypes.homeowner }}>
                                Memberships for Homeowners
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>

                            <NamedLink
                                className={css.ctaButton}
                                name="MembershipPlansPage"
                                params={{ accountType: userTypes.housesitter }}>
                                Memberships for Sitters
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>
                        </div>
                    </>
                } />


            <SectionGrid21
                header={<>
                    <p className={css.sectionTitle}>
                        Benefits of International House Sitting with HouseSit Match
                    </p>
                </>}
                content={<>
                    <div className={css.stepContainer}>
                        <p className={css.subtitle}>
                            For Sitters
                        </p>
                        <p className={css.info}>
                            ✓ Comfortable stays that feel like home while you travel
                        </p>
                        <p className={css.info}>
                            ✓ Clear responsibilities agreed in writing before you go
                        </p>
                        <p className={css.info}>
                            ✓ Verified homeowners and post-sit reviews for transparency
                        </p>
                        <p className={css.info}>
                            ✓ Secure messaging and guidance when you need support
                        </p>
                        <p className={css.info}>
                            ✓ Profiles that showcase your pet and home-care experience
                        </p>
                        <p className={css.info}>
                            ✓ Save on accommodation so you can travel for longer
                        </p>

                    </div>

                    <div className={css.stepContainer}>
                        <p className={css.subtitle}>
                            For Homeowners
                        </p>
                        <p className={css.info}>
                            ✓ Verified sitters who love pets and respect your home
                        </p>
                        <p className={css.info}>
                            ✓ Pets stay in their routine with daily updates while you’re away
                        </p>
                        <p className={css.info}>
                            ✓ Clear expectations for home care, cleaning and utilities
                        </p>
                        <p className={css.info}>
                            ✓ References and reviews to inform your choice
                        </p>
                        <p className={css.info}>
                            ✓ Secure messaging and simple checklists for handovers
                        </p>
                        <p className={css.info}>
                            ✓ Value compared with boarding or paid services
                        </p>
                    </div>
                </>}
                footer={
                    <>
                        <div className="rowMobile fitWidth cenSelf gap20">
                            <NamedLink
                                className={css.ctaButton}
                                name="BenefitsHomeownersPage"
                                params={{ accountType: userTypes.homeowner }}>
                                Benefits for Homeowners
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>

                            <NamedLink
                                className={css.ctaButton}
                                name="BenefitsHouseSittersPage"
                                params={{ accountType: userTypes.housesitter }}>
                                Memberships for Sitters
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>
                        </div>
                    </>
                }
            />

            <SectionGrid21
                backgroundColor="white"
                header={<>
                    <p className={css.sectionTitle}>
                        Memberships and Pricing
                    </p>
                    <p className={css.info}>
                        Create a free account to explore how our service works. Choose a sitter or homeowner membership when you’re ready to connect and confirm a sit abroad.
                    </p>
                </>}
                content={<>
                    <div className={css.card}>
                        <p className={css.subtitle}>
                            Sitter Memberships
                        </p>
                        <p className={css.info}>
                            • Build a verified profile with photos, references, reviews
                        </p>
                        <p className={css.info}>
                            • Secure messaging with homeowners
                        </p>
                        <p className={css.info}>
                            • Guidance and resources for international sits
                        </p>

                        <NamedLink
                            className={css.ctaButton}
                            name="MembershipPlansPage"
                            params={{ accountType: userTypes.housesitter }}>
                            View Sitter Memberships
                            <img src={ContinueIcon} className={css.icon} />
                        </NamedLink>

                    </div>

                    <div className={css.card}>
                        <p className={css.subtitle}>
                            Homeowner Memberships
                        </p>
                        <p className={css.info}>
                            • Verified sitters with references and reviews
                        </p>
                        <p className={css.info}>
                            • Clear expectations agreed up front
                        </p>
                        <p className={css.info}>
                            • Simple handover checklists and support
                        </p>

                        <NamedLink
                            className={css.ctaButton}
                            name="MembershipPlansPage"
                            params={{ accountType: userTypes.homeowner }}>
                            View Homeowner Plans
                            <img src={ContinueIcon} className={css.icon} />
                        </NamedLink>
                    </div>
                </>}
                footer={
                    <div className="col cenV fitWidth cenSelf gap20">
                        <div className='row'>
                            New here? •
                            <NamedLink
                                className={css.link}
                                name="SignupPage">
                                Create your free account
                            </NamedLink>

                        </div>
                    </div>
                }
            />

            <SectionGrid21
                header={<>
                    <p className={css.sectionTitle}>
                        Member Stories From Around the World
                    </p>

                    <p className={css.info}>
                        Real experiences build trust. Here are a few short stories from members who arranged sits abroad with HouseSit Match.
                    </p>
                </>}
                content={<>
                    <div className={css.card}>
                        <img src={AvatarPlaceholder} className={css.reviewerImage} />

                        <p className={css.info}>
                            “Three months in Barcelona caring for two rescue cats. Clear notes on meds and a quick video call made everything smooth — the owners relaxed, we loved the routine.”
                        </p>
                        <p className={css.reviewer}>
                            — Liam, Sitter (IE → ES)
                        </p>

                    </div>

                    <div className={css.card}>
                        <img src={AvatarPlaceholder} className={css.reviewerImage} />

                        <p className={css.info}>
                            “A stormy month in Canada and two huskies to keep happy. Our sitter arrived early, ran through heating and vet contacts, and sent updates throughout.”
                        </p>
                        <p className={css.reviewer}>
                            — Amara, Homeowner (CA)
                        </p>

                    </div>

                    <div className={css.card}>
                        <img src={AvatarPlaceholder} className={css.reviewerImage} />

                        <p className={css.info}>
                            “From Sydney to Sussex: we agreed garden care and arrival timings in writing, and reviews on both sides made confirming quick.”
                        </p>
                        <p className={css.reviewer}>
                            — Priya & Joel, Sitters (AU → UK)
                        </p>

                    </div>

                    <div className={css.card}>
                        <img src={AvatarPlaceholder} className={css.reviewerImage} />

                        <p className={css.info}>
                            “City break without kennel stress — our elderly spaniel stayed in his routine at home, and secure messaging made mid-trip questions easy.”
                        </p>
                        <p className={css.reviewer}>
                            —  Marco & Elena, Homeowners (IT)
                        </p>

                    </div>
                </>}
            />

            <SectionSimpleContainer
                backgroundColor="white"
                header={
                    <>
                        <p className={css.sectionTitle}>
                            Practical Tips for House Sitting Abroad
                        </p>
                        <p className={css.info}>
                            Before you confirm a sit overseas, align on the essentials so travel and pet care run smoothly. Here’s a quick checklist to guide both sides.
                        </p>
                    </>
                }
                content={
                    <>
                        <p className={css.stepTitleColored}>
                            Visas & entry rules
                        </p>
                        <ul>
                            <li>➜ Check the entry requirements for your nationality and length of stay; many sits are unpaid and fit typical visitor rules, but always verify.</li>
                            <li>➜ Confirm dates in writing and keep copies of invitations/agreements for border checks.</li>
                        </ul>

                        <p className={css.stepTitleColored}>
                            Insurance & health
                        </p>
                        <ul>
                            <li>➜ Travel insurance recommended; confirm medical cover and personal liability.</li>
                            <li>➜ Share vet details and a payment/claim plan for emergencies.</li>
                        </ul>

                        <p className={css.stepTitleColored}>
                            Responsibilities & house info
                        </p>
                        <ul>
                            <li>➜ Agree daily pet routines, cleaning, garden/pool care, heating/AC, bins, post, and any HOA/building rules.</li>
                            <li>➜ Create a simple handover pack with appliance guides and Wi-Fi access.</li>
                        </ul>

                        <p className={css.stepTitleColored}>
                            Safety & support
                        </p>
                        <ul>
                            <li>➜ Exchange emergency contacts (owner, neighbour, local vet).</li>
                            <li>➜ Use secure messaging for key updates; keep expectations clear if time zones differ.</li>
                        </ul>
                    </>
                }
                footer={
                    <>
                        <div className="rowMobile fitWidth cenSelf gap20">
                            <NamedLink
                                className={css.ctaButton}
                                name="TrustAndSafetyPage"
                                params={{ accountType: userTypes.homeowner }}>
                                Trust & Safety
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>

                            <a href="https://uk.trustpilot.com/review/housesitmatch.com" target="_blank" rel="noopener noreferrer"
                                className={css.ctaButton}>
                                Reviews
                                <img src={ContinueIcon} className={css.icon} />
                            </a>

                            <NamedLink
                                className={css.ctaButton}
                                name="HouseSittingVisaPage"
                                params={{ accountType: userTypes.housesitter }}>
                                Visas
                                <img src={ContinueIcon} className={css.icon} />
                            </NamedLink>
                        </div>
                    </>
                } />


            <SectionSimpleContainer
                // backgroundColor="white"
                header={
                    <>
                        <p className={css.sectionTitle}>
                            Get Started with House Sitting Abroad
                        </p>
                        <p className={css.info}>
                            Arrange trusted house and pet sitting across borders with a clear process and verified members. Create your free account to set up your profile, learn how memberships work and take the next step when you’re ready.
                        </p>
                    </>}
                footer={<>
                    <div className="col cenV fitWidth cenSelf gap20">
                        <NamedLink
                            className={css.ctaButton}
                            name="SignupPage">
                            Create your free account
                            <img src={ContinueIcon} className={css.icon} />
                        </NamedLink>

                        <div className='row'>
                            <NamedLink
                                className={css.link}
                                name="MembershipPlansPage"
                                params={{ accountType: userTypes.homeowner }}>
                                Sitter memberships
                            </NamedLink>
                            •
                            <NamedLink
                                className={css.link}
                                name="MembershipPlansPage"
                                params={{ accountType: userTypes.homeowner }}>
                                Homeowner plans
                            </NamedLink>

                        </div>
                    </div>
                </>
                }
            />

            <SectionSimpleContainer
                backgroundColor="white"
                header={
                    <p className={css.sectionTitle}>
                        FAQs About House Sitting Abroad
                    </p>
                }
                content={
                    <CollapseFAQ
                        list={faq}
                    />
                } />


        </div>
    )
};

export default DefaultPage;